import React from "react";

interface IDashboardContext {
  wrapperRef?: React.MutableRefObject<HTMLDivElement | undefined>;
}

export const DashboardContext = React.createContext<IDashboardContext>({});
